import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import { green } from "@material-ui/core/colors";
import Alert from "@material-ui/lab/Alert";
import { useAuth0 } from "../../react-auth0-spa";
import config from "../../api_config.json";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
  },
  wrapper: {
    margin: theme.spacing(1),
    position: "relative",
  },
  buttonSuccess: {
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },
  },
  fabProgress: {
    color: green[500],
    position: "absolute",
    top: -6,
    left: -6,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

export default function FormDialog() {
  const classes = useStyles();

  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [couponCode, setCouponCode] = React.useState("");

  const { getTokenSilently } = useAuth0();
  const history = useHistory();

  const validateCoupon = async (couponId) => {
    const token = await getTokenSilently();

    const payload = { couponId };
    const url = `${config.apiUrl[process.env.REACT_APP_ENV]}/redeem-coupon`;
    const response = await fetch(url, {
      method: "post",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const responseData = await response.json();

    if (response.status === 200) {
      return responseData;
    } else {
      throw new Error(responseData.error);
    }
  };

  const handleOnChange = (event) => {
    setCouponCode(event.target.value.toUpperCase());
  };

  const handleRedemption = () => {
    setLoading(true);
    setErrorMessage("");

    validateCoupon(couponCode)
      .then((data) => {
        setLoading(false);
        if (
          data.message === "The coupon is valid" &&
          data.couponId === couponCode &&
          data.options.length > 0
        ) {
          setLoading(false);
          setOpen(false);
          if (data.options.length > 1) {
            // TODO: implement selection of "class type"
          } else if (data.options.length === 1) {
            history.push("/book-lesson", {
              state: { couponCode, couponData: data.options[0] },
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error(error.message);
        setErrorMessage(error.message || "This coupon is not valid.");
      });
  };

  const handleClickOpen = () => {
    setLoading(false);
    setErrorMessage("");
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setCouponCode("");
  };

  return (
    <div className={classes.root}>
      <Button variant="outlined" color="inherit" onClick={handleClickOpen}>
        Redeem Coupon
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Redeem your coupon</DialogTitle>
        <DialogContent>
          <DialogContentText>
            If you have a coupon, enter the code below.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="couponCode"
            label="Coupon Code"
            autoComplete="nooooope"
            type="text"
            value={couponCode}
            onChange={handleOnChange}
            fullWidth
          />
          {errorMessage && (
            <Alert severity="warning">
              <span>{errorMessage}</span>
              <br />
              <span>
                Having issues? Drop me an{" "}
                <a href="mailto:info@juliethspanish.com">email</a>
              </span>
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <div className={classes.wrapper}>
            <Button
              disabled={couponCode.length === 0 || loading}
              onClick={handleRedemption}
              color="primary"
            >
              Redeem
            </Button>
            {loading && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
}
